(() => {

    class HeaderV2 {

        constructor(root) {

            this.root = root;

            this.burger = root.querySelector('[data-burger]');
            this.mobile = root.querySelector('[data-mobile-menu]');

            if (!this.burger || !this.mobile) return;

            this.bind();

        }

        bind() {

            this.burger.addEventListener('click', () => {

                this.toggle();

            });

            document.addEventListener('click', e => {

                if (
                    !this.root.contains(e.target) &&
                    this.mobile.classList.contains('is-open')
                ) {

                    this.close();

                }

            });

            document.addEventListener('keydown', e => {

                if (e.key === 'Escape') {

                    this.close();

                }

            });

            window.addEventListener('resize', () => {

                if (window.innerWidth > 991) {

                    this.close();

                }

            });

        }

        toggle() {

            const opened = this.mobile.classList.toggle('is-open');

            this.burger.classList.toggle('is-open', opened);

            this.burger.setAttribute('aria-expanded', opened);

        }

        close() {

            this.mobile.classList.remove('is-open');

            this.burger.classList.remove('is-open');

            this.burger.setAttribute('aria-expanded', 'false');

        }

    }

    document
        .querySelectorAll('[data-header]')
        .forEach(header => {

            new HeaderV2(header);

        });

})();